import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { useDeviceTypeHook } from '../../../../../shared/src/hooks/use-device-type.hook';
import { SubcategoriesActionsPortal } from '../SubcategoriesActionsPortal';
import './SubcategoriesActionsDialog.css';
import closeIcon from '../../../../images/subcategories/close-icon.svg';
import { SvgIconMask } from '../../../../../shared/src/components/SvgIconMask';

const animationDelay = 100;

export const SubcategoriesActionsDialog = ({
    headerTitleContent,
    bodyContent,
    footerContent,
    onClose,
    show,
    hideCloseButtonOnDesktop = true,
}) => {
    const [render, setRender] = useState(false);
    const [fadeIn, setFadeIn] = useState(false);
    const { isMobile } = useDeviceTypeHook();

    useEffect(() => {
        if (show) {
            setRender(true);
            setTimeout(() => {
                setFadeIn(true);
            }, 50); // add some delay to trigger open animation
        } else if (render) {
            setFadeIn(false);
            setTimeout(() => {
                setRender(false);
            }, animationDelay);
        }
    }, [show]);

    if (!render) {
        return null;
    }

    const className = classNames(
        'asg-subcategories__actions-dialog',
        {
            'asg-subcategories__actions-dialog--in': fadeIn,
            'asg-subcategories__actions-dialog--no-footer-content': !footerContent,
        }
    );
    const closeButtonClasses = classNames(
        'asg-subcategories__actions-dialog-close-action',
        {
            'hide-on-desktop': hideCloseButtonOnDesktop,
        }
    );

    const dialogRendered = (
        <>
            {show && isMobile &&
                <div className="asg-subcategories__actions-dialog-backdrop"
                    onClick={onClose}
                    role="button"
                    tabIndex="0"
                ></div>
            }

            <div className={className}>
                <button className={closeButtonClasses}
                    onClick={onClose}
                >
                    <SvgIconMask
                        iconUrl={closeIcon}
                        bgColor="var(--cs-body-text-color, #ffffff)"
                        width={16}
                        height={16}
                    />
                </button>

                <div className="asg-subcategories__actions-dialog-header">
                    <span className="asg-subcategories__actions-dialog-header-title">
                        {headerTitleContent}
                    </span>
                </div>

                <div className="asg-subcategories__actions-dialog-body">
                    {bodyContent}
                </div>

                <div className="asg-subcategories__actions-dialog-footer">
                    {footerContent}
                </div>
            </div>
        </>
    );

    return (
        <>
            {isMobile && <SubcategoriesActionsPortal>
                {dialogRendered}
            </SubcategoriesActionsPortal>}

            {!isMobile && (
                <>
                    {/* Header is sticky and has greater z-index
                    so another block need to be added to cover the header */}
                    <SubcategoriesActionsPortal>
                        <div className="asg-subcategories__actions-dialog-backdrop-header"
                            onClick={onClose}
                        ></div>
                    </SubcategoriesActionsPortal>

                    {dialogRendered}
                </>
            )}
        </>
    );
};
